import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest
} from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { MonitoringService } from '../monitoring/monitoring.service';
import { SpinnerService } from '../../components/spinner/spinner.service';

@Injectable({ providedIn: 'root' })
export class OirHttpServiceInterceptor implements HttpInterceptor {
  private requestCountSubject: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  private allRequestCount = 0;

  constructor(
    private readonly monitoringService: MonitoringService,
    private spinnerService: SpinnerService
  ) {
    this.requestCountSubject.subscribe(value => {
      if (value > 0) {
        this.spinnerService.show();
      } else {
        this.spinnerService.hide();
      }
    });
  }

  intercept(
    httpRequest: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const hideSpinner = httpRequest.urlWithParams.includes('hideSpinner=true');
    if (!hideSpinner) {
      this.allRequestCount++;
      this.requestCountSubject.next(this.allRequestCount);
    }

    this.monitoringService.logEvent(httpRequest.url, httpRequest.body);

    return next.handle(httpRequest).pipe(
      finalize(() => {
        if (!hideSpinner) {
          this.allRequestCount = this.allRequestCount < 2 ? 0 : this.allRequestCount - 1;
          this.requestCountSubject.next(this.allRequestCount);
        }
      })
    );
  }
}
